import { defineComponent, ref } from 'vue';
export default defineComponent({
    emits: ['confirm'],
    props: {
        text: {
            type: String,
            required: true
        },
        clickFun: {
            type: Function,
            required: true
        }
    },
    setup() {
        const isShowToast = ref(false);
        const isClick = ref(false);
        const test = () => {
            alert(1);
        };
        return {
            isClick,
            isShowToast,
            test
        };
    }
});
